//Node Modules
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useQuery } from "@apollo/client";

//graphql
import { GET_SECTORS } from "../../graphql/home";

//My Components
import { LinkUnderline, MenuLink } from "../helpers";

//3rd Party Components

//Atoms

//Helpers
import { navRoutes } from "../../config/nav";
import Hamburger from "./Hamburger";

const AppNav = ({ role }) => {
	const { pathname } = useLocation();
	const { data, loading, error } = useQuery(GET_SECTORS);

	const [currentLocation, setCurrentLocation] = useState("/");
	const [projectMenuItems, setProjectMenuItems] = useState([]);

	useEffect(() => {
		if (error) console.error(error);
		if (data?.sectorCollection?.items?.length > 0) {
			const buildMenuItems = data.sectorCollection.items.reduce(
				(menuItems, sector) => {
					const menuItem = {
						url: `${navRoutes.projects}/sector/${sector.slug}`,
						label: sector.name,
					};

					menuItems.push(menuItem);
					return menuItems;
				},
				[{ url: `${navRoutes.projects}/sector/all`, label: "All Projects" }]
			);

			setProjectMenuItems(buildMenuItems);
		}
	}, [data, loading, error]);

	useEffect(() => {
		const path = `/${pathname.split("/")[1]}`;
		// console.log("Path ::", path);
		setCurrentLocation(path);
	}, [pathname]);

	return (
		<>
			<nav className={`appNav appNav-${role}`}>
				<LinkUnderline side="bottom" destination={navRoutes.about} text="About" active={currentLocation.startsWith(navRoutes.about)} />
				{/* <LinkUnderline side="bottom" destination={`${navRoutes.projects}/sector/all`} text="Projects" active={currentLocation.startsWith(navRoutes.projects)} /> */}
				<MenuLink id="projectMenuItem" label="Sectors" items={projectMenuItems} path="/projects/sector" showDropIcon />
				{/* <LinkUnderline side="bottom" destination={navRoutes.avExt} text="KPP AV" active={currentLocation.startsWith(navRoutes.avExt)} external /> */}
				<LinkUnderline side="bottom" destination={navRoutes.av} text="KPP:AV" active={currentLocation.startsWith(navRoutes.av)} />
				<LinkUnderline side="bottom" destination={navRoutes.news} text="News" active={currentLocation.startsWith(navRoutes.news)} />
				<LinkUnderline side="bottom" destination={navRoutes.contact} text="Contact" active={currentLocation.startsWith(navRoutes.contact)} />
			</nav>
			<Hamburger />
		</>
	);
};

export default AppNav;
